import {commonAdminQueries} from '@common/admin/common-admin-queries';
import {validateDatatableSearch} from '@common/datatable/filters/utils/validate-datatable-search';
import {PaginatedBackendResponse} from '@common/http/backend-response/pagination-response';
import {queryFactoryHelpers} from '@common/http/queries-file-helpers';
import {keepPreviousData, queryOptions} from '@tanstack/react-query';
import {Inspeccion} from '@app/inspecciones/inspeccion';

const get = queryFactoryHelpers.get;

export const adminQueries = {
  ...commonAdminQueries,

  inspecciones: {
    invalidateKey: ['admin-inspecciones'],
    index: (search: Record<string, string> = {}) => {
      const params = validateDatatableSearch(search);
      return queryOptions({
        placeholderData: keepPreviousData,
        queryKey: ['admin-inspecciones', params],
        queryFn: ({signal}) =>
          get<PaginatedBackendResponse<Inspeccion>>(
            'admin/inspecciones',
            params,
            signal,
          ),
      });
    },
    // Datos para el mapa interactivo del panel admin.
    mapa: () =>
      queryOptions({
        queryKey: ['admin-inspecciones-mapa'],
        queryFn: ({signal}) =>
          get<{inspecciones: (Inspeccion & {color: string})[]}>(
            'admin/inspecciones/mapa',
            {},
            signal,
          ),
      }),
  },

  // URL firmada del dashboard de Metabase ("Indicadores"). El token expira en
  // 10 min; se refresca periódicamente para que el iframe no caduque.
  metabaseDashboard: () =>
    queryOptions({
      queryKey: ['admin-metabase-dashboard'],
      queryFn: ({signal}) =>
        get<{url: string}>('admin/metabase/dashboard', {}, signal),
      staleTime: 8 * 60 * 1000,
      refetchInterval: 9 * 60 * 1000,
      refetchOnWindowFocus: false,
    }),
};
